import { BLOOMREACH_PIXEL_ACCOUNT_ID } from '../../../../../config/config';

export const brScriptSrc = `//cdn.brcdn.com/v1/br-trk-${BLOOMREACH_PIXEL_ACCOUNT_ID}.js`;
